// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoOutlook = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M7.511 9.59q-.702 0-1.115.658t-.413 1.743q0 1.1.413 1.74t1.082.64q.69 0 1.095-.623.405-.622.405-1.727 0-1.152-.393-1.792t-1.074-.64" />,
    <path
      fillRule="evenodd"
      d="M1 20.315V3.479L13.808 1v22zm6.453-4.503q1.305 0 2.117-1.07.813-1.067.812-2.814 0-1.699-.784-2.738-.782-1.038-2.05-1.038-1.342 0-2.157 1.085-.814 1.085-.814 2.841 0 1.663.802 2.699.8 1.035 2.074 1.035"
    />,
    <path d="M14.617 9.968V5.664h7.388c.272 0 .754.37.754.887l-6.473 4.364a.4.4 0 01-.165 0z" />,
    <path d="M15.99 12.516l-1.373-.943v5.849h6.972c.62 0 1.17-.361 1.17-1.222V8.29s-6.381 4.24-6.349 4.23c-.037.02-.245.125-.42-.004" />
  );
export default SvgIconLogoOutlook;
